import React from 'react';

const flattenStyle = (style) => {
	if (!style) return undefined;
	if (!Array.isArray(style)) return style;

	return style.reduce((merged, entry) => {
		if (!entry || typeof entry !== 'object') return merged;
		return { ...merged, ...entry };
	}, {});
};

const withSvgTag = (tag, displayName, mapProps) => {
	const Component = React.forwardRef(({ children, style, ...props }, ref) => {
		const nextProps = mapProps ? mapProps(props) : props;
		return React.createElement(
			tag,
			{
				...nextProps,
				ref,
				style: flattenStyle(style),
			},
			children,
		);
	});

	Component.displayName = displayName;
	return Component;
};

const mapGroupProps = ({ x, y, transform, ...props }) => {
	if (transform || (x == null && y == null)) {
		return { ...props, transform };
	}

	const tx = x ?? 0;
	const ty = y ?? 0;
	return { ...props, transform: `translate(${tx}, ${ty})` };
};

const Svg = withSvgTag('svg', 'Svg');
export const Circle = withSvgTag('circle', 'Circle');
export const G = withSvgTag('g', 'G', mapGroupProps);
export const Line = withSvgTag('line', 'Line');
export const Path = withSvgTag('path', 'Path');
export const Polyline = withSvgTag('polyline', 'Polyline');
export const Text = withSvgTag('text', 'Text');

export default Svg;
